import axios from "axios";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { getAccessToken, getCompanyId, getUserId } from "./utils";
export const FETCH_FB_COMMENTS = "FETCH_FB_COMMENTS";
export const FETCH_QB_COUNTRIES = "FETCH_QB_COUNTRIES";
import { updateProgressBarInfo } from "./queryBuilderActions";

export function fetchFBComments() {
    let res = axios
        .get(getUrl("getFbComments"), {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        })
        .then((resp) => {
            return resp.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });

    return {
        payload: res,
        type: FETCH_FB_COMMENTS,
    };
}

export function addFbComment(params) {
    let progressBarParams = {};
    let config = {};
    config["facebookDataConfigured"] = 1;
    progressBarParams["company_id"] = getCompanyId();
    progressBarParams["user_id"] = getUserId();
    progressBarParams["progress_config"] = config;
    return function (dispatch) {
        let res = axios
            .post(getUrl("addFbComments"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(fetchFBComments()).then(() => {
                    dispatch(updateProgressBarInfo(progressBarParams));
                });
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                throw err;
            });
    };
}
export function deleteFBComment(params) {
    return function (dispatch) {
        let res = axios
            .post(getUrl("deleteFbComments"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((resp) => {
                dispatch(fetchFBComments());
                toast.success(resp.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                throw err;
            });
    };
}

export function countryList() {
    let res = axios
        .get(getUrl("queryBuilderCountryList") + getAccessToken(), {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        })
        .then((resp) => resp.data)
        .catch((err) => toast.error("Error while Fetching QueryBuilder countries"));
    return {
        payload: res,
        type: FETCH_QB_COUNTRIES,
    };
}
